import AdvanceInitContainer from "../../../../Component/Tables/DataTables/AdvanceInit/AdvanceInit"

const AdvanceInit = () => {
  return (
    <div className='page-body'>
      <AdvanceInitContainer />
    </div>
  )
}

export default AdvanceInit